import { env } from '@shared/config/env'

export const generateMerchantUid = (userId: string): string => {
  const timestamp = new Date().toISOString().replace(/[-:]/g, '').slice(0, 14)
  const baseUid = `PODO_F_${userId}_${timestamp}`
  return env.NEXT_PUBLIC_APP_ENV !== 'production' ? `T${baseUid}` : baseUid
}
